import { FeatureDc } from "@evergis/api";

import { DEFAULT_ATTRIBUTE_NAME } from "../constants";
import { getConfigFilter } from "./getConfigFilter";
import { FilterOption } from "../../Dashboard/types";
import { ConfigFilter } from "../types";

export const getListOptions = (items: FeatureDc[], filterName: string, configFilters: ConfigFilter[]) => {
  const filter = getConfigFilter(filterName, configFilters);

  if (!filter) return [];

  return (
    items?.map(item => ({
      text: item.attributes[filter.attributeAlias || DEFAULT_ATTRIBUTE_NAME],
      value: item.attributes[filter.attributeValue || DEFAULT_ATTRIBUTE_NAME],
      min: filter.attributeMin ? item.attributes[filter.attributeMin] : null,
      max: filter.attributeMax ? item.attributes[filter.attributeMax] : null,
    })) || ([] as FilterOption[])
  );
};
